module.exports = __webpack_public_path__ + "img/brands.33d7ab64.png";